import * as yup from 'yup';

import { constants } from 'utils';

const RE_NAME = /^([a-zA-Z]+((-|'|'|—|–|\s)[a-zA-Z]+)*)\s*$/;
const RE_PHONE_AUS = new RegExp(
  /^(\+?61|0) ?(?:\((?=.*\)))?([2-47-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/
);
const RE_PHONE_NZ = new RegExp(
  /^(\+?64) ?(?:\((?=.*\)))?([2-46-9])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{2,3})$/
);
// Following e164 format and use the regex
// that is provided by twillio: https://www.twilio.com/docs/glossary/what-e164#regex-matching-for-e164.
const RE_INTERNATIONAL_NUMBER = new RegExp(/^\+[1-9]\d{1,14}$/);

const INVALID_FIRST_NAME_ERROR_MESSAGE =
  'That doesn’t look like a valid given name. Please try again.';
const INVALID_LAST_NAME_ERROR_MESSAGE =
  'That doesn’t look like a valid family name. Please try again.';
const INVALID_PHONE_NUMBER_ERROR_MESSAGE =
  'That doesn’t look like a valid phone number. Please try again.';

const checkNameRegex = (value: string) => !/\d+/.test(value) && RE_NAME.test(value);
const startsWith = (theString: string, value: string) => theString.indexOf(value) === 0;

export const schema = yup.object().shape({
  firstName: yup
    .string()
    .required(constants.GenericValidationErrors.required)
    .test('isValidFirstName', INVALID_FIRST_NAME_ERROR_MESSAGE, checkNameRegex),
  lastName: yup
    .string()
    .required(constants.GenericValidationErrors.required)
    .test('isValidLastName', INVALID_LAST_NAME_ERROR_MESSAGE, checkNameRegex),
  contactNumber: yup
    .string()
    .required(constants.GenericValidationErrors.required)
    .test('isValidPhone', INVALID_PHONE_NUMBER_ERROR_MESSAGE, (contactNumber: string) =>
      validateContactNumber(contactNumber)
    )
});

function validateContactNumber(contactNumber: string) {
  if (
    startsWith(contactNumber, '+61') ||
    startsWith(contactNumber, '61') ||
    startsWith(contactNumber, '0')
  ) {
    return RE_PHONE_AUS.test(contactNumber);
  } else if (startsWith(contactNumber, '+64') || startsWith(contactNumber, '64')) {
    return RE_PHONE_NZ.test(contactNumber);
  }

  return RE_INTERNATIONAL_NUMBER.test(contactNumber);
}
